// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"312":"b0a0c90dd5bb247b","685":"53bab305ae574f9b"}[chunkId] + ".js";
};